import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const MyActionsContext = createContext(null);

// Single authoritative fetch of the current user's "My Actions" data, shared by the
// nav attention badge (Layout) and the Home page panels. Mounted ABOVE the profile
// loading gate so it fires as soon as a session exists — in parallel with /me, not
// serially after it.
export function MyActionsProvider({ children }) {
  const { session } = useAuth();
  const uid = session?.user?.id || null;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const reload = useCallback(async () => {
    if (!uid) return;
    setLoading(true);
    try {
      const r = await api.get("/my-actions");
      setData(r.data);
    } catch (_) {
      /* leave last-known data; sections just show "Nothing right now." */
    } finally {
      setLoading(false);
    }
  }, [uid]);

  useEffect(() => {
    if (uid) reload();
    else setData(null);
  }, [uid, reload]);

  return (
    <MyActionsContext.Provider value={{ data, loading, reload }}>
      {children}
    </MyActionsContext.Provider>
  );
}

export const useMyActions = () =>
  useContext(MyActionsContext) || { data: null, loading: false, reload: () => {} };
